import React, { Component } from 'react';
import Input from "sushiweb/InputTypes/Input";

import Accordian from './../../commonComponents/Accordian/Accordian';
import './AssetTracking.scss';
import DropdownComponent from '../../core/DropdownComponent';

class AssetCard extends Component {

    getAssetDetails = (assetDetail) => {
        const { assetName, deliveredQuantity, recievedQuantity} = assetDetail;
        if(assetName === "Select Asset Type" || deliveredQuantity === "" || recievedQuantity === "") {
            return false;
        }
        return  true;
    }

    getDisplayName = () => {
        const { assetDetail, assetTypes } = this.props;
        const selectedMenu = assetTypes.filter(item => {
          return item.value === assetDetail.assetName;
        })
        if(selectedMenu.length) {
          return selectedMenu[0]['displayName'];
        } else {
          return "Select Asset Type"
        }
    }

    render() {
        const { assetDetail , onChange, index , showForm,isUploaded,showDelete, showActiveIndex, onDelete, filteredAssetList } = this.props;

        const hasAllField = this.getAssetDetails(assetDetail) || false;
        const displayName = this.getDisplayName();
        return (
            <Accordian title={`Asset ${index+1}`} 
                description={displayName === "Select Asset Type" ? "" : displayName } 
                hasContent={hasAllField}
                showForm={showForm}
                index={index}
                showActiveIndex={showActiveIndex}
                onDelete={onDelete}
                showDelete={showDelete}
                isUploaded={isUploaded}
            >
            <DropdownComponent
              menu={filteredAssetList}
              defaultParam={{ value: assetDetail.assetName}}
              className={isUploaded ? "flex-margin small-content gray-text disabled": "flex-margin small-content gray-text"}
              primary={true}
              handleClick={(filters) => onChange(filters.value, 'assetName', index)}
              displayName={displayName}
              displayKeyName="displayName"
              isUploaded={isUploaded}
            />
            <div className="inputs">
              <div className="input-field">
                <Input label="Qty Delivered" value={`${assetDetail.deliveredQuantity}`} onChange={(value) => onChange( value, 'deliveredQuantity', index)}/>
              </div>
              <div className="input-field">
                <Input label="Qty Recieved" value={`${assetDetail.recievedQuantity}`} onChange={(value) => onChange(value, 'recievedQuantity', index)}/>
              </div>
            </div>
          </Accordian>
        )
    }
}

export default AssetCard;